import type { User as FirebaseAuthUser } from 'firebase/auth';
import type { ConnectApi, EmailUser } from 'hydra-data-types';
import { REFERRAL_URL_TYPE } from '../constants';

export type ConnectInitializeUser = ConnectApi.InitializeHcpResult['user'];
export type StoreStateInternal = {
  user: ConnectInitializeUser | EmailUser | undefined;
  firebaseUser: FirebaseAuthUser | undefined;
  userStatus: { firstTimeVisit: boolean };
  authenticatingExistingMindsetId: boolean;
  hcpReferralHash: string | undefined;
  referralUrlType: REFERRAL_URL_TYPE;
};

// eslint-disable-next-line no-shadow
export enum ActionType {
  SET_USER,
  SET_HCP_PATIENT_LINK_ID,
  SET_FIREBASE_USER,
  SET_USER_STATUS,
  SET_EMAIL_VERIFICATION_CODE,
  SET_AUTHENTICATING_EXISTING_MINDSET_ID,
  CLEAR_USER,
  SET_API_HEALTH,
  SET_REFERRAL_URL_TYPE,
}
